const Theme = {
  body_background_color: '#F7F7F7',

  logo_image_url: 'auxtroiscouvents.png',
  logo_height: 120,

  token_hidden: true,
  number_hidden: true,

  title_font: `'Lato', sans-serif`,
  title_size: 35,
  title_lineheight: 42,
  title_letter_spacing: 1,
  title_weight: 700,

  subtitle_font: 'Lato, serif',
  subtitle_size: 20,
  subtitle_lineheight: 26.8,
  subtitle_letter_spacing: 0.2,
  subtitle_weight: 400,
  subtitle_uppercase: true,

  text_font: `'Raleway', sans-serif`,

  button_color: '#49182D',
  button_radius: 50,
  button_font: 'Lato, serif',
  button_text_size: 14,
  button_text_uppercase: true,
  button_text_weight: 600,
  button_padding: '10px 25px',

  separator_color: '#B3C651',
  separator_height: 4,
}

export default Theme
